export default __webpack_public_path__ + "static/media/wilpez.ebf49ad9.jpg";